import {useContext} from 'react';

import {Navigate, Outlet} from 'react-router-dom';

import {UserContext} from '../../contexts/UserContext/UserContext';
import {AppConfig} from '../../lib/AppConfig';

export const CompanySignedContractGuard = () => {
  const {isLoading, isRoleCompany, isContractSigned} = useContext(UserContext);

  if (isLoading) {
    return null;
  }

  return isRoleCompany && isContractSigned ? <Outlet /> : <Navigate to={AppConfig.COMPANY_NOT_SIGNED_PATH} />;
};
